import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import './Dropdown.scss';
import Chevron from '../../svg/icons/caret.svg';
import Icon from '../Icon';

function getOptions(option) {
  const { label } = option;

  return (
    <option
      {...option}
    >
      {label}
    </option>
  );
}

function getLabel(options, value) {
  const o = options.find(
    (option) => option.value === value
  );
  return o && o.label;
}

const DropdownSimple = ({
  ariaLabel,
  className,
  disabled,
  icon,
  name,
  onChange,
  onClick,
  options,
  value,
}) => (
  <div className={cx('Dropdown', className, { 'Dropdown__Stylized--disabled': disabled })}>
    <select
      disabled={disabled}
      id={name}
      name={name}
      onChange={onChange}
      onClick={onClick}
      value={value}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      {options.map(getOptions)}
    </select>
    <div className="Dropdown__Stylized" aria-hidden>
      {icon && (
        <Icon component={icon} iconClass="ticket" />
      )}
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <div htmlFor={name}>{getLabel(options, value)}</div>
      <Chevron
        transform="rotate(180)"
        className="chevron"
      />
    </div>
  </div>
);

DropdownSimple.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ariaLabel: PropTypes.string,
};

DropdownSimple.defaultProps = {
  className: undefined,
  disabled: false,
  icon: undefined,
  name: undefined,
  onChange: () => {},
  onClick: undefined,
  options: [],
  value: undefined,
  ariaLabel: null,
};

DropdownSimple.displayName = 'DropdownSimple';

export default DropdownSimple;
